import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData
} from './utils';
import { PixelsVideoEvent } from '../../constants/Video';
import { MetricsStorage } from './types';

export const startImpression = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
  const adTimeChange$ = sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.AD_IMPRESSION, PixelsVideoEvent.AD_ENDED,PixelsVideoEvent.AD_SKIPPED,
      // video
      PixelsVideoEvent.FIRST_FRAME,
      PixelsVideoEvent.VIDEO_ENDED
    ].includes(type as PixelsVideoEvent)),
    map(([type]) => [PixelsVideoEvent.AD_IMPRESSION, PixelsVideoEvent.FIRST_FRAME].includes(type as PixelsVideoEvent))
  );

  adTimeChange$.subscribe(() => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;

    const data:  MetricsStorage = getData(storageKey);
    metricsLog(`Ad impression recorded`);

    setData(storageKey, {
      ...data,
      start_impression: {
        value: true
      },
    });
  });
};